import { ArrowRight, Filter, Plus, Search } from "react-feather";
import styles from "./keyfobfilter.module.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [
    { value: "Tenant", label: "Tenant" },
    { value: "User", label: "User" },
    { value: "Other", label: "Other" },
];

const KeyfobFilter = ({ filterData, setFilterData, setShowAddFormKeyFob, setPage }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data?.data || []);
            }).catch((error) => {
                console.error('[Keyfobs] Failed to load property list for filter', error);
                toast.error(error?.response?.data?.message || 'Unable to load properties. Please try again.');
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    return <div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={!filterOpen ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Property"
                        options={propertyList}
                        value={filterData?.property}
                        onChange={(value) => {
                            setFilterData((prev) => ({ ...prev, property: value }));
                            setPage(0);
                        }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Type"
                        options={TYPE_OPTIONS}
                        value={filterData?.type}
                        onChange={(value) => {
                            setFilterData((prev) => ({ ...prev, type: value }));
                            setPage(0);
                        }}
                    />
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device-keyfob:create") > -1) && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setShowAddFormKeyFob(true)}>
                <Plus /> <span>KeyFob</span>
            </Link>}
        </div>
    </div>
}

export default KeyfobFilter;